import { render, staticRenderFns } from "./addDocument.vue?vue&type=template&id=6f1e58ed&scoped=true"
import script from "./addDocument.vue?vue&type=script&lang=js"
export * from "./addDocument.vue?vue&type=script&lang=js"
import style0 from "./addDocument.vue?vue&type=style&index=0&id=6f1e58ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1e58ed",
  null
  
)

export default component.exports